export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Diesel technicians, mechanics, diagnostic technicians, apprentices and heavy-duty technicians.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. DIESEL DIAGNOSTIC PRO™ is a 100% digital resource.',
  },
  {
    question: 'Is this a training course or certification?',
    answer: 'No. It is a practical professional diesel diagnostic reference system.',
  },
  {
    question: 'Is it another theory-heavy ebook?',
    answer:
      'No. It focuses on visual diagnostic workflows, testing guides, decision trees, scan-data references and workshop tools.',
  },
  {
    question: 'What areas are included?',
    answer:
      'Diagnostic workflow, fuel and common rail, turbo and boost, electronics, emissions and advanced diesel fault diagnosis.',
  },
  {
    question: 'Does this replace professional procedures or manufacturer instructions?',
    answer:
      'No. Always follow manufacturer documentation, professional safety procedures and applicable workplace requirements.',
  },
  {
    question: 'How will I receive it?',
    answer: "You'll receive immediate digital access after purchase.",
  },
  {
    question: 'Does it work for light-duty, heavy-duty and agricultural diesel engines?',
    answer:
      'The diagnostic workflows, testing sequences and decision trees are built around diesel systems that are common across light-duty, heavy-duty, agricultural and industrial applications, such as common rail, turbo and boost control, sensors and aftertreatment. Manufacturer-specific values and procedures must always come from the documentation for the engine in front of you.',
  },
  {
    question: 'Do I need a specific scan tool or expensive equipment to use it?',
    answer:
      'No. The scan-data references explain what to look at and how to compare commanded and actual values with the tools you already use in the workshop, from generic scan tools to manufacturer-level equipment.',
  },
  {
    question: 'Is it a one-time payment, and how does the refund work?',
    answer:
      'It is a single payment for immediate digital access to the complete 6-module system and all 5 professional bonuses. If it is not right for you, contact us within 7 days for a full refund according to the refund terms.',
  },
]
